import React from 'react';
import {
	Autocomplete,
	Box,
	TextField,
	IconButton,
	Tooltip,
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Employee } from '../../types/employee';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
interface TimesheetSelectorsProps {
	// Define your props here
	selectedEmployee: Employee | null;
	setSelectedEmployee: (employee: Employee | null) => void;
	loadingEmployees: boolean;
	employees: Employee[];
	selectedDate: Date;
	setSelectedDate: (date: Date) => void;
	loadingTimesheetEntries: boolean;
	fetchTimesheetEntries: () => void;
}

const TimesheetSelectors: React.FC<TimesheetSelectorsProps> = (props) => {
	// Add your component logic here
	const {
		selectedEmployee,
		setSelectedEmployee,
		loadingEmployees,
		employees,
		selectedDate,
		setSelectedDate,
		loadingTimesheetEntries,
		fetchTimesheetEntries,
	} = props;

	const isSameDate = (date1: Date, date2: Date) => {
		return (
			date1.getFullYear() === date2.getFullYear() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getDate() === date2.getDate()
		);
	};

	const handlePrevDay = () => {
		const newDate = new Date(selectedDate);
		newDate.setDate(newDate.getDate() - 1);
		newDate.setHours(0, 0, 0, 0);
		setSelectedDate(newDate);
	};

	const handleNextDay = () => {
		const newDate = new Date(selectedDate);
		newDate.setDate(newDate.getDate() + 1);
		newDate.setHours(0, 0, 0, 0);
		setSelectedDate(newDate);
	};

	const handleToday = () => {
		const newDate = new Date();
		newDate.setHours(0, 0, 0, 0);
		setSelectedDate(newDate);
	};

	return (
		<>
			<Autocomplete
				value={selectedEmployee}
				onChange={(event, newValue) => {
					if (newValue !== null) {
						setSelectedEmployee(newValue);
					}
				}}
				loading={loadingEmployees}
				fullWidth
				options={employees}
				getOptionLabel={(option) => option.FullName}
				renderInput={(params) => (
					<TextField {...params} label="Employee" />
				)}
				disabled={loadingTimesheetEntries}
			/>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<DatePicker
					value={selectedDate}
					onChange={(newValue) => {
						if (newValue && !isSameDate(selectedDate, newValue)) {
							const newDate = new Date(
								newValue.setHours(0, 0, 0, 0),
							);
							setSelectedDate(newDate);
						}
					}}
					label="Date"
					disabled={loadingTimesheetEntries}
					renderInput={(params) => (
						<TextField {...params} fullWidth />
					)}
				/>
			</LocalizationProvider>
			<Box
				display={'flex'}
				justifyContent={'center'}
				alignItems={'center'}
			>
				<Box
					display={'flex'}
					borderRadius={9999}
					border={'2px solid white'}
				>
					<Tooltip title="Prev Day">
						<span>
							<IconButton
								onClick={handlePrevDay}
								disabled={
									loadingTimesheetEntries || !selectedEmployee
								}
								size="small"
							>
								<ArrowBackIosIcon />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Today">
						<span>
							<IconButton
								onClick={handleToday}
								disabled={
									loadingTimesheetEntries || !selectedEmployee
								}
								size="small"
							>
								<EventAvailableIcon />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Next Day">
						<span>
							<IconButton
								onClick={handleNextDay}
								disabled={
									loadingTimesheetEntries || !selectedEmployee
								}
								size="small"
							>
								<ArrowForwardIosIcon />
							</IconButton>
						</span>
					</Tooltip>
				</Box>
				<Tooltip title="Refresh Entries">
					<span>
						<IconButton
							onClick={fetchTimesheetEntries}
							disabled={
								loadingTimesheetEntries || !selectedEmployee
							}
						>
							<RefreshIcon />
						</IconButton>
					</span>
				</Tooltip>
			</Box>
		</>
	);
};

export default TimesheetSelectors;
